import {controller, target} from '@github/catalyst'

@controller
class CheckboxAutoSubmitElement extends HTMLElement {
  @target form: HTMLFormElement
  @target checkbox: HTMLInputElement
  @target loadingIndicator: HTMLElement
  @target failureIndicator: HTMLElement

  connectedCallback() {
    const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content
    if (!csrfToken) return

    // Handle setting token if element was updated by turbo stream
    let tokenInput = this.form.querySelector('input[name="authenticity_token"]') as HTMLInputElement
    if (!tokenInput) {
      tokenInput = document.createElement('input')
      tokenInput.type = 'hidden'
      tokenInput.name = 'authenticity_token'
      this.form.appendChild(tokenInput)
    }
    tokenInput.value = csrfToken
  }

  async submitForm() {
    let startingValue = !this.checkbox.checked
    this.displayLoadingIndicator()

    const formData = new FormData(this.form)
    const response = await fetch(this.form.action, {
      method: this.form.method,
      body: formData,
      headers: {'X-Requested-With': 'XMLHttpRequest'},
    })

    if (response.status === 200) {
      this.resetIndicators()
    } else {
      this.checkbox.checked = startingValue
      this.displayFailureIndicator()
    }
  }

  private resetIndicators() {
    this.failureIndicator.hidden = true
    this.loadingIndicator.hidden = true
  }

  private displayLoadingIndicator() {
    this.resetIndicators()
    this.loadingIndicator.hidden = false
  }

  private displayFailureIndicator() {
    this.resetIndicators()
    this.failureIndicator.hidden = false
  }
}
